module.exports = __webpack_public_path__ + "static/media/allergen_mustard.275942f0.png";